import * as userTokenRequests from "../../api/userTokenRequest";
import { START_LOAD, FINISH_LOAD } from "../reducers/user";
import { push } from "./message";
import { getTeamProfile } from "./team";

const startLoading = () => {
  return { type: START_LOAD };
};
const finishLoading = (user) => {
  return { type: FINISH_LOAD, payload: user };
};

export const getUserProfile = () => {
  return (dispatch) => {
    dispatch(startLoading());
    userTokenRequests
      .getUserProfile()
      .then((user) => {
        dispatch(finishLoading(user));
      })
      .catch((error) => {
        dispatch(finishLoading(null));
        dispatch(push(error.message));
      });
  };
};

export const updateUserProfile = (
  phone,
  country,
  address,
  nick_name,
  first_name,
  last_name,
  date_of_birthday,
  avatar,
  receive_newsletter,
  receive_updates,
  email,
  post_code,
  suburb,
  state,
  license,
  id,
  teamId
) => {
  return (dispatch) => {
    userTokenRequests
      .updateUserProfile(
        phone,
        country,
        address,
        nick_name,
        first_name,
        last_name,
        date_of_birthday,
        avatar,
        receive_newsletter,
        receive_updates,
        email,
        post_code,
        suburb,
        state,
        license,
        id,
        teamId
      )
      .then((user) => {
        teamId ? dispatch(getTeamProfile(teamId)) : dispatch(getUserProfile());
        dispatch(
          push(
            !id
              ? "Your profile has been updated"
              : "License updated successfully"
          )
        );
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};
